import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=3642753a&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=3642753a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642753a",
  null
  
)

export default component.exports